// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from '../../store/index'
import enter from './enter.vue'
import '../../assets/css/common.css'
import '../../assets/css/article.css'
import { shareChannel, MD5, getSearchString } from '../../api/utils/common'
Vue.config.productionTip = false
new Vue({
  store,
  components: { enter },
  template: '<enter />',
  el: '#app',
  created: function () {
    store.dispatch('requestHot')
    store.dispatch('requestRecommend')
    if (/userId/i.test(location.hash)) {
      let articleId = location.hash.split('&')[0].slice(1)
      store.dispatch('requestContent', articleId)
    } else {
      let articleId = location.hash.slice(1)
      store.dispatch('requestContent', articleId)
    }

    // store.dispatch('requestContent', '700840288553492480')
    let userId = getSearchString(location.hash, 'userId')
    if (userId) {
      setTimeout(function () {
        var Fingerprint2 = window.Fingerprint2 || {}
        Fingerprint2.get((components) => {
          let finger = MD5(JSON.stringify(components))
          // console.log(finger)
          let payload = {
            id: userId,
            url: 'http://mobile.auto.sohu.com/m/article.html?pvid=3a89a4b3' + location.hash,
            identity: finger || '',
            channel: shareChannel()
          }
          // console.log(payload)
          store.dispatch('requestShare', payload)
        })
      }, 500)
    }
  }
})



// WEBPACK FOOTER //
// ./src/page/article/article.js